import {
  hotspotIcon,
  generateCustomIconXml
} from '~js/helpers'
import { componentGalleryXml } from './component-gallery'

const getMarkerGalleryXml = function (marker, ath, atv, useCustomIcon, index, markerScale, krpanoVrModeObj) {
  let gallery = ''
  const opacity = marker.opacity ? (marker.opacity / 100) : 0.6
  const objectId = marker.objectId
  const imagesLength = 1
  if (marker.customCoordinate && marker.coordinatePlane !== 0 && marker.rotation) {
    const inverserotation = (marker.coordinatePlane === 3)
    const rx = marker.coordinatePlane === 3 ? 90 - atv + (-90 - marker.rotation.x) : atv
    const ry = marker.coordinatePlane === 3 ? 0 : -ath + 90 - marker.rotation.y
    const rz = marker.rotation.z
    gallery += `<hotspot
      name="marker_${marker.objectId}"
      style="${hotspotIcon(marker, useCustomIcon)}"
      scale="${markerScale}"
      ath="${ath}"
      atv="${atv}"
      zorder="${marker.index}"
      distorted="true"
      inverserotation="${inverserotation}"
      rx="${rx}"
      ry="${ry}"
      rz="${rz}"
      alpha="${opacity}"
      mipmapping="true"
      enabled="${!marker.disabled}"
      capture="false"
      ${generateCustomIconXml(marker)}
      onclick="
        set_marker_info(${index});
        marker_mousein(${objectId}, ${index});
        if (webvr.isenabled,
          close_webXR_marker(${opacity});
          ini_webXR_gallery_variable(${imagesLength});
          ini_webXR_common_variable(${objectId});
          set_webXR_marker_gallery_scale_html();
          set_webXR_marker_gallery_position(${ath}, ${atv - 13});
          set_webXR_marker_gallery_size();
          set_webXR_marker_gallery_offset();
          set_webXR_gallery_buttons_img();
          set_webXR_button_events(${opacity}, null);
      "
      onover="marker_mousein(${marker.objectId}, ${index});"
      onout="marker_mouseout(${marker.objectId}, ${index}, null, ${opacity});" />`
  } else {
    gallery += `<hotspot
      name="marker_${marker.objectId}"
      style="${hotspotIcon(marker, useCustomIcon)}"
      scale="${markerScale}"
      ath="${ath}"
      atv="${atv}"
      zorder="${marker.index}"
      alpha="${opacity}"
      enabled="${!marker.disabled}"
      capture="false"
      ${generateCustomIconXml(marker)}
      onclick="
        set_marker_info(${index});
        marker_mousein(${objectId}, ${index});
        if (webvr.isenabled,
          close_webXR_marker(${opacity});
          ini_webXR_gallery_variable(${imagesLength});
          ini_webXR_common_variable(${objectId});
          set_webXR_marker_gallery_scale_html();
          set_webXR_marker_gallery_position(${ath}, ${atv - 13});
          set_webXR_marker_gallery_size();
          set_webXR_marker_gallery_offset();
          set_webXR_gallery_buttons_img();
          set_webXR_button_events(${opacity}, null);
        );"
      onover="marker_mousein(${marker.objectId}, ${index});"
      onout="marker_mouseout(${marker.objectId}, ${index}, null, ${opacity});" />`
  }
  const markerObj = { images: [marker.photo], objectId }

  gallery += componentGalleryXml(
    markerObj,
    krpanoVrModeObj,
    'reopen_webXR_marker(null);'
  )
  return gallery
}

export default getMarkerGalleryXml
